import React, { useEffect, useId, useRef, useState } from "react";
import { HelpCircle, X } from "lucide-react";
import { GLOSSARY } from "../../lib/portalHelp";
import { GuideLink } from "./PortalShell";

/**
 * A "?" next to a term the trainer may not know (06.10.2026). A click, not a
 * hover — it has to work on a phone; Escape or a click elsewhere closes it.
 */
export default function Hint({ term, align = "left" }) {
  const g = GLOSSARY[term];
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  const id = useId();

  useEffect(() => {
    if (!open) return undefined;
    const away = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", away);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", away);
      document.removeEventListener("keydown", esc);
    };
  }, [open]);

  if (!g) return null;
  return (
    <span ref={box} className="relative inline-flex align-middle normal-case tracking-normal">
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-controls={id}
        aria-label={`Ce înseamnă: ${g.title}`}
        className="inline-grid h-5 w-5 place-items-center rounded-full text-[#9CA3AF] hover:text-[#965EA7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#965EA7]"
        data-testid={`portal-hint-${term}`}>
        <HelpCircle size={15} />
      </button>
      {open && (
        <span id={id} role="note"
          className={`absolute top-6 z-30 w-72 max-w-[80vw] rounded-xl border border-[#E5E7EB] bg-white p-3 text-left text-xs font-normal leading-relaxed text-[#373A45] shadow-lg ${align === "right" ? "right-0" : "left-0"}`}>
          <span className="mb-1 flex items-center justify-between gap-2">
            <span className="text-sm font-semibold">{g.title}</span>
            <button type="button" onClick={() => setOpen(false)} aria-label="Închide" className="text-[#9CA3AF] hover:text-[#373A45]">
              <X size={14} />
            </button>
          </span>
          {g.text}
          <span className="mt-2 block"><GuideLink query={g.title}>Caută în ghid</GuideLink></span>
        </span>
      )}
    </span>
  );
}
